module.exports = __webpack_public_path__ + "img/gzh.2027592f.png";